var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65043 0H12.7559C13.6637 0 14.4063 0.761862 14.4063 1.6929V6.66501H13.2367V2.71081C13.2367 1.93091 12.6146 1.29271 11.8542 1.29271H2.5519C1.79157 1.29271 1.1695 1.93079 1.1695 2.71081V13.2143C1.1695 13.9942 1.79157 14.6324 2.5519 14.6324H11.8542C12.6145 14.6324 13.2367 13.9943 13.2367 13.2143V10.7046H14.4063V14.2322C14.4063 15.1634 13.6636 15.9251 12.7559 15.9251H1.65043C0.742629 15.9251 0 15.1633 0 14.2322V1.69278C0 0.761617 0.742748 0 1.65043 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40631 0.529804L9.76492 4.92112C10.4088 5.25936 10.9347 6.06944 10.9385 6.7242L11.0123 19.1919C11.0162 19.8561 10.4928 20.1765 9.8441 19.9012L1.41779 16.3261C0.686288 16.0157 0.0827606 15.1768 0.0827606 14.4648V1.10862C0.0827606 0.407489 0.681146 0.14875 1.40631 0.529804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7364 7.84663H19.0378C19.3769 7.84663 19.6542 8.13113 19.6542 8.47894V9.18154C19.6542 9.52935 19.3769 9.81385 19.0378 9.81385H12.7364C12.3973 9.81385 12.1199 9.52935 12.1199 9.18154V8.47894C12.1199 8.13113 12.3973 7.84663 12.7364 7.84663Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9302 4.90211L19.887 8.52629C20.0217 8.69142 20.0001 8.93949 19.8393 9.07763L19.3762 9.47512C19.2152 9.61326 18.9733 9.5913 18.8387 9.42617L15.8819 5.80187C15.7472 5.63673 15.7686 5.38867 15.9296 5.25053L16.3927 4.85304C16.5537 4.71489 16.7956 4.7371 16.9302 4.90211Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9548 12.7316L19.9115 9.10744C20.0462 8.94231 20.0247 8.69424 19.8638 8.5561L19.4007 8.15861C19.2397 8.02047 18.9978 8.04243 18.8632 8.20756L15.9064 11.8319C15.7717 11.997 15.7931 12.2451 15.9541 12.3832L16.4172 12.7807C16.5782 12.9188 16.8201 12.8966 16.9548 12.7316Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a6bbc0b7d82826b282b87e34f00127a0.svg";
export { ForwardRef as ReactComponent };